// @ts-nocheck

const MESSAGE_TYPE_CLASSES = ["error", "info", "success", "warning", "error-1"];
const MESSAGE_TYPE_SET = new Set(MESSAGE_TYPE_CLASSES);

const SUCCESS_MESSAGE_TYPES = {
  DELIVERY_AVAILABLE: "success",
};

/**
 * @param {number} amount
 * @returns {string}
 */
function formatYen(amount) {
  return new Intl.NumberFormat("ja-JP").format(Math.round(amount));
}

const MESSAGES = {
  loading: `<span class='message-heading'>確認中です</span><br><span class="message-heading-2">配送可能エリアを照合しています...</span>`,
  requiredAddress: "都道府県・市区町村・番地まで入力してください",
  destinationNotFound: "配送先が見つかりませんでした。",
  genericError: `<span class="message-heading">エラーが発生しました</span> <br><span class="message-heading-2">通信に失敗しました。しばらく経ってから再度お試しください。</span>`,
  deliveryAvailable: (warehouseName, warehouseAddress) =>
    `<span class="message-heading"></span><span class="message-heading-2">配送可能です</span>`,
  // deliveryAvailable: (warehouseName, warehouseAddress) =>
  //   `<span class="message-heading"></span><span class="message-heading-2">${warehouseName}（${warehouseAddress}）より対応可能です。担当者よりご連絡いたします。</span>`,
  helpText: (address, warehouseName, distanceKm) =>
    `※配送先：${address}（出荷拠点からの距離: ${distanceKm}km）`,
  shippingPageHelpText: (address, warehouseName, distanceKm, totalFee) =>
    `配送先：${address}（出荷拠点からの距離: ${distanceKm}km）`,
  // helpText: (address, warehouseName, distanceKm) =>
  //   `※配送先：${address}（${warehouseName}: ${distanceKm}km）`,
  // shippingPageHelpText: (address, warehouseName, distanceKm, totalFee) =>
  //   `配送先：${address}（${warehouseName}: ${distanceKm}km）`,
};

class FormCheckAddress extends HTMLElement {
  errorMessagesByCode = {
    VALIDATION_TOO_SHORT: {
      type: "error-1",
      message: MESSAGES.requiredAddress,
    },
    OUT_OF_DELIVERY_AREA: {
      type: "error",
      message: `<span class="message-heading">配送対応エリア外です</span> <br><span class="message-heading-2">現在、配送は対応しておりません。対応エリアは東京・大阪・名古屋近郊となります。</span>`,
    },
    ADDRESS_AMBIGUOUS: {
      type: "warning",
      message: `<span class="message-heading">住所を特定できませんでした。<br>番地までご入力ください。</span> <br><span class="message-heading-2">番地や建物名まで入力いただくと、より正確に判定できます。</span>`,
    },
    BOUNDARY_AREA_CHECK: {
      type: "warning",
      message: `<span class="message-heading">対応エリア境界のため要確認です</span> <br><span class="message-heading-2">ご住所がエリア境界付近のため、個別にご案内します。お問い合わせください。</span>`,
    },
  };

  connectedCallback() {
    if (this._connected) return;
    this._connected = true;
    this.init();

    const isShippingPage = this.#isShippingPageMode();

    if (isShippingPage) {
      this.show();
    }

    setTimeout(() => {
      if (!this.hasFullAddress()) return;

      if (isShippingPage) {
        if (this.dataset.initialCheckDone === "true") return;
        this.dataset.initialCheckDone = "true";
        this.runCheck();
        return;
      }

      if (!window._ymqInitialAutoCheckDone) {
        window._ymqInitialAutoCheckDone = true;
        this.runCheck();
      }
    }, 0);
  }

  #isShippingPageMode() {
    return this.dataset.context === "shipping-page";
  }

  init() {
    if (this._initialized) return;
    this._initialized = true;

    this.form = this.querySelector("form[data-main-form]");
    this.container = this.querySelector(".form-check-address-container");
    this.searchInput = this.querySelector("[data-search-input]");
    this.searchWrapper = this.querySelector("[data-search-wrapper]");
    this.searchMessage = this.querySelector("[data-search-message]");
    this.helpTextMessage = this.querySelector("[data-help-text]");
    this.feeResultEl = this.querySelector("[data-shipping-fee-result]");
    this.submitButton = this.querySelector('[data-main-form] button[type="submit"]');

    if (this.form) this.form.addEventListener("submit", (e) => this.handleSubmit(e));
  }

  show() {
    this.container?.classList.remove("hidden");
  }

  hasFullAddress() {
    return Boolean(this.searchInput?.value?.trim());
  }

  async handleSubmit(/** @type {Event} */ e) {
    e?.preventDefault();
    await this.runCheck();
  }

  async runCheck() {
    if (!this.form || this._checking) return;
    this._checking = true;

    const payload = this.getPayload();
    if (!payload.full_address) {
      this.showSearchMessage(MESSAGES.requiredAddress, "error-1");
      this._checking = false;
      return;
    }

    this.resetYmqStateForNewAddress(payload.full_address);

    try {
      this.setLoadingState(true);
      const result = await this.submitAddress(payload);
      this.show();

      if (!result?.success) {
        this.showErrorByCode(result?.error);
        return;
      }

      this.handleSuccessResult(payload.full_address, result.data || {});
    } catch (error) {
      console.error("[form-check-address] runCheck error:", error);
      this.showSearchMessage(MESSAGES.genericError, "error");
    } finally {
      this.setLoadingState(false);
      this._checking = false;
    }
  }

  handleSuccessResult(fullAddress, data) {
    const nearestWarehouse = data?.nearest_warehouse;
    const warehouseName = nearestWarehouse?.name;
    const warehouseAddress = nearestWarehouse?.full_address;
    const distanceKm = data?.distance?.distance_km;
    const totalFee = data?.price?.total_fee;
    const apiHeader = data?.header;
    const apiBody = data?.body;
    const apiCode = data?.code;

    if (apiHeader || apiBody) {
      this.showSearchMessage(
        this.#buildApiMessage(apiHeader, apiBody),
        this.#getSuccessMessageType(apiCode),
      );
    } else if (warehouseName && warehouseAddress) {
      this.showSearchMessage(
        MESSAGES.deliveryAvailable(warehouseName, warehouseAddress),
        "success",
      );
    } else {
      this.showSearchMessage(MESSAGES.destinationNotFound, "error-1");
      return;
    }

    if (typeof distanceKm !== "number") return;

    if (this.#isShippingPageMode() && typeof totalFee === "number") {
      this.showHelpTextMessage(
        MESSAGES.shippingPageHelpText(fullAddress, warehouseName, distanceKm, totalFee),
      );
      this.#showShippingFeeResult(totalFee);
    } else {
      this.showHelpTextMessage(MESSAGES.helpText(fullAddress, warehouseName, distanceKm));
    }

    if (this.#isShippingPageMode()) {
      return;
    }

    if (window._ymqLastDistance !== distanceKm) {
      window._ymqLastDistance = distanceKm;
      this.dispatchEvent(
        new CustomEvent("ymq:shipping-calculated", {
          bubbles: true,
          detail: {
            distance_km: distanceKm,
            full_address: fullAddress,
            response: data,
          },
        }),
      );
    }

    this.setCartShippingAddressProperty(fullAddress);
  }

  #buildApiMessage(header, body) {
    const safeHeader = header ? String(header).trim() : "";
    const safeBody = body ? String(body).trim() : "";

    if (safeHeader && safeBody) {
      return `<span class="message-heading">${safeHeader}</span> <br>${safeBody}`;
    }

    if (safeHeader) {
      return `<span class="message-heading">${safeHeader}</span>`;
    }

    return safeBody;
  }

  #getSuccessMessageType(code) {
    if (code && SUCCESS_MESSAGE_TYPES[code]) {
      return SUCCESS_MESSAGE_TYPES[code];
    }

    return "success";
  }

  #showShippingFeeResult(totalFee) {
    if (!(this.feeResultEl instanceof HTMLElement) || typeof totalFee !== "number") {
      return;
    }

    this.feeResultEl.innerHTML = `基本送料（概算）：<strong>¥${formatYen(totalFee)}</strong>（税込）`;
    this.feeResultEl.hidden = false;
  }

  async submitAddress(/** @type {{ full_address: string }} */ payload) {
    try {
      const response = await fetch(this.form.action, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) return await response.json();

      const { error } = await response.json().catch(() => ({}));
      return { success: false, error: error || { message: "住所確認に失敗しました" } };
    } catch (error) {
      return { success: false, error: { message: error.message } };
    }
  }

  setLoadingState(/** @type {boolean} */ isLoading) {
    if (this.submitButton) {
      this.submitButton.textContent = isLoading ? "確認中..." : "確認する";
      this.submitButton.disabled = isLoading;
    }
    if (isLoading) this.showSearchMessage(MESSAGES.loading, "info");
  }

  #messageHasContent(/** @type {string} */ message) {
    if (!message) return false;

    const probe = document.createElement("div");
    probe.innerHTML = String(message);
    return Boolean(probe.textContent.replace(/\u00a0/g, " ").trim());
  }

  showSearchMessage(
    /** @type {string} */ message,
    /** @type {string} */ type = "info",
  ) {
    if (!this.searchMessage || !this.searchWrapper) return;

    const hasContent = this.#messageHasContent(message);
    this.searchWrapper.classList.remove(...MESSAGE_TYPE_CLASSES);
    this.searchMessage.innerHTML = hasContent ? message : "";
    this.searchMessage.hidden = !hasContent;
    this.searchMessage.style.display = hasContent ? "block" : "none";
    if (hasContent && MESSAGE_TYPE_SET.has(type)) this.searchWrapper.classList.add(type);
  }

  showHelpTextMessage(/** @type {string} */ message) {
    if (!this.helpTextMessage) return;
    this.helpTextMessage.textContent = message;
    this.helpTextMessage.style.display = message ? "block" : "none";
  }

  #clearShippingFeeResult() {
    if (!(this.feeResultEl instanceof HTMLElement)) return;
    this.feeResultEl.hidden = true;
    this.feeResultEl.textContent = "";
  }

  setCartShippingAddressProperty(fullAddress) {
    const input = document.querySelector(".ymq-shipping-address input");
    if (input) input.value = fullAddress;
  }

  getPayload() {
    if (!this.form) return { full_address: "" };
    const formData = new FormData(this.form);
    return {
      full_address: String(formData.get("full_address") || "").trim(),
    };
  }

  showErrorByCode(error) {
    const config = this.errorMessagesByCode[error?.code];
    if (config) {
      this.showSearchMessage(config.message, config.type);
      return;
    }

    if (error?.message) {
      const fallbackType = MESSAGE_TYPE_SET.has(error?.type) ? error.type : "info";
      this.showSearchMessage(error.message, fallbackType);
      return;
    }

    this.showSearchMessage(MESSAGES.genericError, "error");
  }

  resetYmqStateForNewAddress(fullAddress) {
    const normalized = String(fullAddress || "").trim();
    if (!normalized || normalized === this._lastSubmittedAddress) return;
    this._lastSubmittedAddress = normalized;

    this.showHelpTextMessage("");
    this.#clearShippingFeeResult();

    if (this.#isShippingPageMode()) {
      return;
    }

    window._ymqLastDistance = null;

    if (window.YMQCustom?.unlockAllShippingWrappers) {
      window.YMQCustom.unlockAllShippingWrappers();
    }

    const shippingSelect = document.querySelector(".shipping_fee_auto_select select");
    if (shippingSelect) {
      const placeholderOption =
        shippingSelect.querySelector("option[value='']") ||
        shippingSelect.querySelector("option[data-placeholder]");

      if (placeholderOption) {
        shippingSelect.value = placeholderOption.value;
      } else {
        shippingSelect.selectedIndex = -1;
        shippingSelect.value = "";
      }

      shippingSelect
        .querySelectorAll("option[selected]")
        .forEach((opt) => opt.removeAttribute("selected"));
      if (shippingSelect.selectedIndex >= 0) {
        shippingSelect.options[shippingSelect.selectedIndex]?.setAttribute("selected", "selected");
      }

      delete shippingSelect.dataset.autoSelected;
      delete shippingSelect._lastFired;
      shippingSelect.dispatchEvent(new Event("input", { bubbles: true }));
      shippingSelect.dispatchEvent(new Event("change", { bubbles: true }));
    }

    const shippingAddressInput = document.querySelector(".ymq-shipping-address input");
    if (shippingAddressInput) {
      shippingAddressInput.value = "";
      shippingAddressInput.dispatchEvent(new Event("input", { bubbles: true }));
      shippingAddressInput.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}

if (!customElements.get("form-check-address")) {
  customElements.define("form-check-address", FormCheckAddress);
}
